import React, { useState } from 'react';
import { motion } from 'motion/react';
import { UserPlus, ArrowRight } from 'lucide-react';

interface UserRegistrationFormProps {
  onSubmit: (data: any) => void;
  onSwitchToLogin: () => void;
  isLoading: boolean;
}

export const UserRegistrationForm = ({ onSubmit, onSwitchToLogin, isLoading }: UserRegistrationFormProps) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    province: '',
    city: '',
    district: '',
  });

  return (
    <div className="max-w-md mx-auto px-4 py-20">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-[3rem] shadow-2xl shadow-slate-200/50 border border-slate-100 overflow-hidden"
      >
        <div className="p-10 md:p-12">
          <div className="text-center mb-10">
            <div className="w-20 h-20 bg-emerald-500 rounded-[2rem] flex items-center justify-center mx-auto mb-6 shadow-xl shadow-emerald-500/20 rotate-3">
              <UserPlus className="w-10 h-10 text-white" />
            </div>
            <h2 className="text-3xl font-bold text-slate-900 mb-2 tracking-tight">Buat Akun Baru</h2>
            <p className="text-slate-500 text-sm">Mulai pengalaman cukur rambut terbaik Anda.</p>
          </div>

          <form onSubmit={(e) => { e.preventDefault(); onSubmit(formData); }} className="space-y-6">
            <div className="space-y-2">
              <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-4">Nama Lengkap</label>
              <input 
                required
                disabled={isLoading}
                type="text" 
                value={formData.name}
                onChange={e => setFormData({ ...formData, name: e.target.value })}
                className="w-full bg-slate-50 border-2 border-slate-50 rounded-2xl px-6 py-4 focus:border-emerald-500 focus:bg-white transition-all outline-none text-slate-900 font-medium disabled:opacity-50"
                placeholder="Masukkan nama lengkap"
              />
            </div>
            <div className="space-y-2">
              <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-4">Email</label>
              <input 
                required
                disabled={isLoading}
                type="email" 
                value={formData.email}
                onChange={e => setFormData({ ...formData, email: e.target.value })}
                className="w-full bg-slate-50 border-2 border-slate-50 rounded-2xl px-6 py-4 focus:border-emerald-500 focus:bg-white transition-all outline-none text-slate-900 font-medium disabled:opacity-50"
                placeholder="nama@email.com"
              />
            </div>
            <div className="space-y-2">
              <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-4">Nomor HP</label>
              <input 
                required
                disabled={isLoading}
                type="tel" 
                value={formData.phone}
                onChange={e => setFormData({ ...formData, phone: e.target.value })}
                className="w-full bg-slate-50 border-2 border-slate-50 rounded-2xl px-6 py-4 focus:border-emerald-500 focus:bg-white transition-all outline-none text-slate-900 font-medium disabled:opacity-50"
                placeholder="08123456789"
              />
            </div>
            <div className="grid grid-cols-1 gap-6">
              <div className="space-y-2">
                <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-4">Provinsi</label>
                <input 
                  required
                  disabled={isLoading}
                  type="text" 
                  value={formData.province}
                  onChange={e => setFormData({ ...formData, province: e.target.value })}
                  className="w-full bg-slate-50 border-2 border-slate-50 rounded-2xl px-6 py-4 focus:border-emerald-500 focus:bg-white transition-all outline-none text-slate-900 font-medium disabled:opacity-50"
                  placeholder="Provinsi"
                />
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-4">Kota/Kabupaten</label>
                <input 
                  required
                  disabled={isLoading}
                  type="text" 
                  value={formData.city}
                  onChange={e => setFormData({ ...formData, city: e.target.value })}
                  className="w-full bg-slate-50 border-2 border-slate-50 rounded-2xl px-6 py-4 focus:border-emerald-500 focus:bg-white transition-all outline-none text-slate-900 font-medium disabled:opacity-50"
                  placeholder="Kota/Kabupaten"
                />
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-4">Kecamatan</label>
                <input 
                  required
                  disabled={isLoading}
                  type="text" 
                  value={formData.district}
                  onChange={e => setFormData({ ...formData, district: e.target.value })}
                  className="w-full bg-slate-50 border-2 border-slate-50 rounded-2xl px-6 py-4 focus:border-emerald-500 focus:bg-white transition-all outline-none text-slate-900 font-medium disabled:opacity-50"
                  placeholder="Kecamatan"
                />
              </div>
            </div>

            <button 
              type="submit"
              disabled={isLoading}
              className="w-full py-5 rounded-2xl bg-emerald-500 text-white font-bold hover:bg-emerald-600 transition-all shadow-xl shadow-emerald-500/20 active:scale-[0.98] mt-4 flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Memproses...' : 'Daftar'}
              {!isLoading && <ArrowRight className="w-5 h-5" />}
            </button>
          </form>

          <div className="mt-8 pt-8 border-t border-slate-50 text-center">
            <p className="text-sm text-slate-500">
              Sudah punya akun?{' '}
              <button 
                onClick={onSwitchToLogin}
                className="text-emerald-500 font-bold hover:underline"
              >
                Masuk di sini
              </button>
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
